module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('li', {
    class: {
      read: _vm.email.isRead
    }
  }, [_vm._v(_vm._s(_vm.email.subject))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1976ac88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/EmailPreview.vue
// module id = 279
// module chunks = 1